import axios from 'axios';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { getError } from '@shared/utils/helpers';
import { SERVICES } from '@shared/constants/apiConfig';
import { withQueryParams } from '@shared/commonFunctions';

const BASEURL = `${SERVICES.WORKFLOW}/trkr/upsert`;

export const requestChangeSortOrder = async (sortOrder: number[]) => {
  try {
    await axios.post(`${BASEURL}/sortorder`, sortOrder);
    Notistack.successMessage('Sorted order updated successfully');
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestUpsertNote = async (dealId: string, note: string) => {
  try {
    await axios.post(withQueryParams(`${BASEURL}/note/deal/${dealId}`, { note }));
    Notistack.successMessage('Note updated successfully');
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};
